    // Importa las funciones que necesitas de los SDKs que necesitas
    import { initializeApp } from "firebase/app";
    import { getAuth } from "firebase/auth";
    import { getFirestore } from "firebase/firestore";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAuCxcV7Iq8UgppAwGomTiS9AXO0VjGjSk",
  authDomain: "boletines-app.firebaseapp.com",
  projectId: "boletines-app",
  storageBucket: "boletines-app.firebasestorage.app",
  messagingSenderId: "156133904272",
  appId: "1:156133904272:web:2fcf15f2ba17da878cad15",
  measurementId: "G-X4Y56V8N85"
};
// Inicializa Firebase
    const app = initializeApp(firebaseConfig);

    // Exporta los servicios que necesitarás en tu aplicación
    export const auth = getAuth(app);
    export const db = getFirestore(app);

